import { CourseAuthor } from "@jelly/lesson";
import appConfig from "appConfig";

const author: CourseAuthor = {
  name: "Karolina Jaruszewska",
  title: "Head of Education Department at KFB Acoustics",
  description: `orn in Poland in 1986. Graduate of the Faculty of Electronics at Wroclaw University of Technology and a postgraduate Master Class of Management program at SWPS University. A Project Manager with a specialization in acoustics, she currently chairs the technical committee for education at EAA. Since 2014, she has been overseeing international educational projects at KFB Acoustics and serves as the coordinator for the acoucou.org educational platform. She is a co-author of the illustrated book "Halo! Tu dzwięk!". Her work primarily revolves around interdisciplinary areas bridging the realms of science, engineering, and art.



  <ul>
    <li><a href="https://www.researchgate.net/profile/Karolina-Jaruszewska" target="_blank">Research</a></li>

    </ul>
  `,
  imageUrl: appConfig.ASSETS_URL + "/05/authors/karolina-jaruszewska.jpg",
};

export default author;
